import moment from 'moment';

import {
    getCreateDateTime
} from '../../utils/DateUtils';
import { parseCurrency } from '../../utils/SamuiUtils';

export const pkListMasterModel = () => {
    return {
        docId: null,
        compId: window.localStorage.getItem('company'),
        docNo: null,
        docDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docStatus: parseCurrency("1"),
        reqStcStatus: parseCurrency("0"),
        deliveryLineId: null,
        pkCarId: null,
        pkCarNo: null,
        pkRound: null,
        pkDriver1Id: null,
        pkDriver2Id: null,
        pkDriver3Id: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        pkDocType: null
    };
};